<template>
  <div class="check">
    <van-nav-bar :border="true"
                 :title="title">
    </van-nav-bar>
    <div class="contain"
         :style="{'padding-top': isWechat ? '10px' : '56px' }">
      <div class="pagenums">
        {{ (currentPageIndex || 0) + 1 }} / {{pageNums}}
      </div>
      <div :id="'item-page_' + index"
           :style="{height: imgHeight + 'px'}"
           class="cell"
           v-for="(page, index) in pageNums"
           :key="index">
        <div :id="'loading-page_' + index"
             class="loading-page"
             v-show="imgWidth">
          <img src="../../assets/images/signer/imgloading.gif"
               style="width:30px;height:30px" />
        </div>
        <draggable v-show="item.show"
                   v-for="(item, sIndex) in signerArr[index]"
                   @showModal="showModal($event, index, sIndex, item)"
                   :key="sIndex"
                   :picUrl="item.imgUrl"
                   :parentIndex="index"
                   :index="sIndex"
                   :signType="4"
                   :w="item.w"
                   :h="item.h"
                   :preview="item.old"
                   :x="item.x"
                   :y="item.y">
        </draggable>
        <draggable v-show="item.show"
                   v-for="(item, dIndex) in dateArr[index]"
                   :key="'d' + dIndex"
                   :picUrl="item.imgUrl"
                   :parentIndex="index"
                   :index="dIndex"
                   :signType="5"
                   :w="item.w"
                   :h="item.h"
                   :preview="item.old"
                   :x="item.x"
                   :y="item.y">
        </draggable>
        <draggable v-show="item.show"
                   v-for="(item, dIndex) in signatureArr[index]"
                   @showModal="showModal($event, index, dIndex, item)"
                   :key="'s' + dIndex"
                   :picUrl="item.imgUrl"
                   :parentIndex="index"
                   :index="dIndex"
                   :signType="6"
                   :w="item.w"
                   :preview="item.old"
                   :h="item.h"
                   :x="item.x"
                   :y="item.y">
        </draggable>
        <draggable v-show="item.show"
                   v-for="(item, rIndex) in ridingArr"
                   @showModal="showModal($event, index, rIndex, item)"
                   :key="'r' + rIndex"
                   :picUrl="item.imgUrl"
                   :parentIndex="index"
                   :index="rIndex"
                   :signType="7"
                   :w="item.w"
                   :h="item.h"
                   :preview="item.old"
                   :x="item.x"
                   :y="item.y">
        </draggable>
        <div class="cellarea">
          <div @click="check(sitem)"
               class="signItem"
               v-for="(sitem, sindex) in page.signList"
               :key="sindex"
               :style="{
                  position: 'absolute',
                  width: sitem.width + 'px',
                  height: sitem.height + 'px',
                  lineHeight: sitem.height + 'px',
                  transform: `translateX(${sitem.x}px) translateY(${sitem.y}px) translateZ(0px) scale(1)`,
                }">
            <div class="urlView"
                 v-if="sitem.sign.picUrl">
              <div class="movUrl">
                <img :style="{height: sitem.height + 'px'}"
                     :src="sitem.sign.picUrl" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :style="{height: imgHeight + 'px', backgroundColor: '#EEEEEE'}"
           v-if="isShort"></div>
    </div>
    <div class="footer">
      <div @click="change"
           class="left">
        <div>当前版本：{{currentTitle || '原始文件'}}</div>
        <div>
          <van-icon size='16'
                    color="#000000"
                    name="exchange" />
        </div>
      </div>
      <div class="right"
           @click="check">
        一键校验
      </div>
    </div>
    <van-popup v-model="show"
               position="bottom"
               class="poppadding"
               :safe-area-inset-bottom="true"
               :style="{ maxHeight: 300 + 'px', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }">
      <div class="popView">
        <div @click="changeVersion(0)"
             class="version">
          <div class="left">
            <div class="top">原始文件</div>
            <div class="down">{{ (fileDetail.createTime) | formatDate('YYYY-MM-DD HH:mm:ss')}}</div>
          </div>
          <div v-if="currentIndex === 0"
               class="right red">当前版本</div>
        </div>
        <div @click="changeVersion(index + 1)"
             class="version"
             v-for="(item, index) in versionList"
             :key="index">
          <div class="left">
            <div class="top"
                 v-text="getName(item)"></div>
            <div class="down">{{ (item.createTime) | formatDate('YYYY-MM-DD HH:mm:ss')}}</div>
          </div>
          <div v-if="currentIndex !== versionList.length && index === versionList.length - 1"
               class="right red">最新版本</div>
          <div v-else-if="currentIndex === index + 1"
               class="right red">当前版本</div>
        </div>
        <div class="lineView"></div>
        <div @click="show = false"
             class="cancel">取消</div>
      </div>
    </van-popup>
    <van-popup @close="closePop"
               style="border-radius: 10px"
               :close-on-click-overlay="false"
               v-model="showCheck">
      <div class="popCheck">
        <div class="topnav">
          <div class="header"
               style="calc(100% - 30px)">
            <div>{{checkTitle}}</div>
            <div>
              <van-icon size="20"
                        name="cross"
                        @click="closePop" />
            </div>
          </div>
          <div class="checkArea">
            <div v-if="ruleValidationState == 0">
              <van-icon size='20'
                        color="#2d8cf0"
                        name="info" />
            </div>
            <div v-if="ruleValidationState == 1">
              <van-icon size='20'
                        color='#19be6b'
                        name="checked" />
            </div>
            <div v-if="ruleValidationState == 2">
              <van-icon size='20'
                        color='#e60000'
                        name="clear" />
            </div>
            <div class="title"
                 v-if="ruleValidationState == 0">{{checkTitle}}中</div>
            <div class="title"
                 v-if="ruleValidationState == 1">签名有效</div>
            <div class="title"
                 v-if="ruleValidationState == 2">签名无效</div>
            <!-- <div v-if="ruleValidationState == 0"
                 class="item-img"> -->
            <img src="../../assets/images/signer/imgloading.gif"
                 alt=""
                 class="item-img"
                 v-if="ruleValidationState == 0">
            <!-- <van-icon size='20'
                        color='#999999'
                        name="replay" /> -->
            <!-- </div> -->
          </div>
        </div>
        <div id="popBody"
             class="popBody">
          <div class="signature-desc">
            <div class="info-title"
                 style="margin-top:10px">签名信息：</div>
            <div class="info-content"
                 v-if="currentVC">
              <div class="content-item">
                <div class="item-title">印章合约地址：</div>
                <div class="item-value"
                     v-if="currentVC.cptId === 10001">{{currentVC.claim.personSeal}}</div>
                <div class="item-value"
                     v-if="currentVC.cptId === 10002">{{currentVC.claim.companySeal}}</div>
              </div>
              <div v-if="currentVC.cptId === 10001"
                   class="content-item">
                <div class="item-title">姓名：</div>
                <div class="item-value">{{currentVC.personalInfo.claim.name}}</div>
              </div>
              <div v-else
                   class="content-item">
                <div class="item-title">所属企业：</div>
                <div class="item-value">{{currentVC.companyInfo.claim.exterpriseName}}</div>
              </div>
              <div class="content-item">
                <div class="item-title">区块链数字身份：</div>
                <div class="item-value"
                     v-if="currentVC.cptId === 10001">{{currentVC.personalInfo.claim.did}}</div>
                <div class="item-value"
                     v-if="currentVC.cptId === 10002">{{currentVC.companyInfo.claim.did}}</div>
              </div>
              <div v-if="currentVC.type !== 0"
                   class="content-item">
                <div class="item-title">当前使用者：</div>
                <div class="item-value">{{currentVC.personalInfo.claim.name}}</div>
              </div>
              <div class="content-item">
                <div class="item-title">交易hash：</div>
                <div class="item-value">{{ currentTxid }}</div>
              </div>
              <div class="content-item">
                <div class="item-title">操作时间：</div>
                <div class="item-value">{{formatDate(currentVC.proof.created * 1)}}</div>
              </div>
              <div v-if="chainSignTime"
                   class="content-item">
                <div class="item-title">签名上链时间：</div>
                <div class="item-value">{{formatDate(chainSignTime * 1000)}}</div>
              </div>
            </div>
          </div>
          <div v-if="ruleValidationState === 1"
               class="signature-desc">
            <div style="height: 10px"></div>
            <div class="info-title">有效性小结</div>
            <div class="info-content">
              <div class="content-item">1.符合《电子签名法》第十三条中可靠电子签名的规定</div>
              <div class="content-item">2.自签名人签署后，电子签名未被更改</div>
              <div class="content-item">3.自签名人签署后，由电子签名保护的文档内容未被更改</div>
            </div>
          </div>
        </div>
        <div style="height: 10px"></div>
        <div class="popFooter">
          <div @click="showCheck = false"
               class="btn">确定</div>
        </div>
      </div>
    </van-popup>
    <van-popup @close="closePop"
               style="border-radius: 10px"
               v-model="checkModal"
               :closeable="true">
      <div class="popCheck">
        <div class="check-file">
          <div class="check-header">
            <p>文件校验</p>
            <div class="checkStatus"
                 style="color: #FF0000"
                 v-if="checkStatus === 0">校验中<span class="dot">...</span></div>
            <div class="checkStatus"
                 v-if="checkStatus === 1"
                 style="color: #2d8cf0">校验成功</div>
            <div class="checkStatus"
                 style="color: #FF0000"
                 v-if="checkStatus === 2">校验失败</div>
            <div class="checkStatus"
                 v-if="checkStatus === -1"></div>
            <!-- <span @click="check">一键校验</span> -->
          </div>
          <div class="check-list">
            <div class="check_item">
              <div class="item-title2"
                   :class="{active: hashStatus == 1, err: hashStatus == 0}">原始文件hash校验</div>
              <!-- <Icon type="ios-loading"
                      class="item-img"
                      v-if="ruleValidationState == 0" /> -->
              <img src="../../assets/images/signer/imgloading.gif"
                   alt=""
                   class="item-img"
                   v-if="ruleValidationState == 0">
              <img src="../../assets/images/check/right.png"
                   alt=""
                   class="item-status-img"
                   v-else-if="ruleValidationState == 1">
              <img src="../../assets/images/check/error.png"
                   alt=""
                   class="item-status-img"
                   v-else-if="ruleValidationState == 2">
            </div>
            <div v-for="(item, index) in signJsonArrCopy"
                 :key="index">
              <div class="item-title3">{{item.checkTitle}}</div>
              <div class="check_item">
                <div>
                  <div class="item-title2"
                       :class="{active: item.checkFormatStatus == 1, err: item.checkFormatStatus == 0}">{{item.checkFormat}}{{'(' + (index + 1) + ')'}}</div>
                </div>
                <!-- <Icon type="ios-loading"
                        class="item-img"
                        v-if="item.checkFormatState == 0" /> -->
                <img src="../../assets/images/signer/imgloading.gif"
                     alt=""
                     class="item-img"
                     v-if="item.checkFormatState == 0">
                <img src="../../assets/images/check/right.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkFormatState == 1">
                <img src="../../assets/images/check/error.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkFormatState == 2">
              </div>
              <div class="check_item">
                <div class="item-title2"
                     :class="{active: item.checkIssuerIdVCStatus == 1, err: item.checkIssuerIdVCStatus == 0}">{{item.checkIssuerIdVC}}{{'(' + (index + 1) + ')'}}</div>
                <!-- <Icon type="ios-loading"
                        class="item-img"
                        v-if="item.checkIssuerIdVCState == 0" /> -->
                <img src="../../assets/images/signer/imgloading.gif"
                     alt=""
                     class="item-img"
                     v-if="item.checkIssuerIdVCState == 0">
                <img src="../../assets/images/check/right.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkIssuerIdVCState == 1">
                <img src="../../assets/images/check/error.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkIssuerIdVCState == 2">
              </div>
              <div v-if="item.vc.cptId === 10002"
                   class="check_item">
                <div class="item-title2"
                     :class="{active: item.checkCompanyIdVCStatus == 1, err: item.checkCompanyIdVCStatus == 0}">{{item.checkCompanyIdVC}}{{'(' + (index + 1) + ')'}}</div>
                <!-- <Icon type="ios-loading"
                        class="item-img"
                        v-if="item.checkCompanyIdVCState == 0" /> -->
                <img src="../../assets/images/signer/imgloading.gif"
                     alt=""
                     class="item-img"
                     v-if="item.checkCompanyIdVCState == 0">
                <img src="../../assets/images/check/right.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkCompanyIdVCState == 1">
                <img src="../../assets/images/check/error.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkCompanyIdVCState == 2">
              </div>
              <div class="check_item">
                <div class="item-title2"
                     :class="{active: item.checkVCSignStatus == 1, err: item.checkVCSignStatus == 0}">{{item.checkVCSign}}{{'(' + (index + 1) + ')'}}</div>
                <!-- <Icon type="ios-loading"
                        class="item-img"
                        v-if="item.checkVCSignState == 0" /> -->
                <img src="../../assets/images/signer/imgloading.gif"
                     alt=""
                     class="item-img"
                     v-if="item.checkVCSignState == 0">
                <img src="../../assets/images/check/right.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkVCSignState == 1">
                <img src="../../assets/images/check/error.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkVCSignState == 2">
              </div>
              <div class="check_item">
                <div class="item-title2"
                     :class="{active: item.checkVCSignValidStatus == 1, err: item.checkVCSignValidStatus == 0}">{{item.checkVCSignValid}}{{'(' + (index + 1) + ')'}}</div>
                <!-- <Icon type="ios-loading"
                        class="item-img"
                        v-if="item.checkVCSignValidState == 0" /> -->
                <img src="../../assets/images/signer/imgloading.gif"
                     alt=""
                     class="item-img"
                     v-if="item.checkVCSignValidState == 0">
                <img src="../../assets/images/check/right.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkVCSignValidState == 1">
                <img src="../../assets/images/check/error.png"
                     alt=""
                     class="item-status-img"
                     v-else-if="item.checkVCSignValidState == 2">
              </div>
            </div>
          </div>
          <div v-if="isCheckDone"
               class="check-detail"
               @click="showCheckModal = true, checkModal = false">文件校验详情</div>
        </div>
      </div>
    </van-popup>
    <van-popup @close="closePop"
               style="border-radius: 10px"
               :close-on-click-overlay="false"
               v-model="showCheckModal"
               :closeable="true">
      <div class="verity-modal popCheck">
        <div class="signature-desc">
          <div class="info-content">
            <div class="content-item"><span class="item-title title">文件hash：</span>
              <span class="item-value">{{fileDetail.fileInfo.pdfHash}}<span class="detail"
                      @click="checkHashModal = true">校验</span></span>
            </div>
            <div class="content-item"><span class="item-title title">创建时间：</span><span class="item-value">{{formatDate(fileDetail.createTime)}}</span></div>
          </div>
        </div>
        <div class="signature-desc">
          <div class="info-title">
            <p>签署方</p>
          </div>
          <div class="werp-center">
            <div v-for="(item, index) in signJsonArrCopy"
                 :key="index"
                 class="info-content info-warp">
              <div v-if="item.vc.cptId === 10001 && item.record"
                   class="content-item"><span class="item-title title">签署方：</span><span class="item-value">{{item.record.memberName}}</span></div>
              <div v-if="item.vc.cptId === 10002 && item.record"
                   class="content-item"><span class="item-title title">签署方：</span><span class="item-value">{{item.record.companyName}}</span></div>
              <div v-if="item.vc.cptId === 10001"
                   class="content-item"><span class="item-title title">DID：</span><span class="item-value">{{item.vc.issuer}}</span></div>
              <div v-if="item.vc.cptId === 10002"
                   class="content-item"><span class="item-title title">DID：</span><span class="item-value">{{item.vc.claim.companyDid}}</span></div>
              <div v-if="item.vc.cptId === 10001"
                   class="content-item"><span class="item-title title">印章合约地址：</span><span class="item-value">{{item.vc.claim.personSeal}}</span></div>
              <div v-if="item.vc.cptId === 10002"
                   class="content-item"><span class="item-title title">印章合约地址：</span><span class="item-value">{{item.vc.claim.companySeal}}</span></div>
              <div v-if="item.vc.cptId === 10002"
                   class="content-item"><span class="item-title title">操作人：</span><span class="item-value">{{item.record.memberName}}</span></div>
              <div v-if="item.vc.cptId === 10002"
                   class="content-item"><span class="item-title title">DID：</span><span class="item-value">{{item.vc.issuer}}</span></div>
              <div v-if="item.vc.cptId === 10001"
                   class="content-item"><span class="item-title title">操作行为：</span><span class="item-value">签字</span></div>
              <div v-else
                   class="content-item"><span class="item-title title">操作行为：</span><span class="item-value">盖章</span></div>
              <div class="content-item"><span class="item-title title">操作时间：</span><span class="item-value">{{formatDate(item.vc.proof.created * 1)}}</span></div>
              <div v-if="item.chainSignTime"
                   class="content-item"><span class="item-title title">签名上链时间：</span><span class="item-value">{{formatDate(item.chainSignTime * 1000)}}</span></div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup @close="closePop"
               style="border-radius: 10px;"
               :close-on-click-overlay="false"
               v-model="checkHashModal"
               :closeable="true">
      <div class="verity-modal popCheck">
        <div v-if="fileDetail && fileDetail.fileInfo"
             class="id-warp">
          <div class="signature-desc">
            <div class="info-content">
              <div class="content-item"><span class="item-title title">原始文件hash：</span><span class="item-value">{{fileDetail.fileInfo.pdfHash}}</span></div>
              <div class="content-item"><span class="item-title title">当前文件hash：</span><span class="item-value">{{fileDetail.fileInfo.pdfHash}}</span></div>
              <div class="content-last">当前文件无改动</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// import { Notify, Toast, Dialog } from 'vant'
import { shareFileDetail, fileHashQuery, queryStatusByHash, chainSimpleQuery } from '../../api/file'
import { Base64 } from 'js-base64'
import chainmaker from '@/utils/chainmaker'
import Storm3 from 'storm3'
import utils from '@/utils/contractInfo'
import Web3 from 'web3'
import draggable from '@/components/draggable'
import { hidePhone } from '@/utils/index'
import Contracts from '@/libs/contracts/contracts'
import { formatDate } from '@/utils/date'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
import { mapState } from 'vuex'
import baseUrl from '@/interface'
const pdfjs = require('pdfjs-dist')
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker
var storm3 = new Storm3(
  new Storm3.providers.HttpProvider('https://testyinji.gaoshan.co/moac-chain/')
)
var web3 = new Web3()
export default {
  name: 'check',
  data: function () {
    return {
      baseUrl,
      title: '文件核验',
      fileHashObj: {},
      picUrlList: [],
      isWechat: false,
      signerArr: [],
      dateArr: [],
      showCheckModal: false,
      checkHashModal: false,
      signatureArr: [],
      ridingArr: [],
      currentPageIndex: 0,
      checkModal: false,
      fileDetail: {
        fileInfo: {}
      },
      imgHeight: 0,
      imgWidth: 0,
      pageHeigt: 0,
      pageNums: 0,
      isShort: false,
      pageWidth: 0,
      userPhone: '',
      pix: 200 / 25.4,
      ratio: 1,
      show: false,
      versionList: [],
      currentIndex: 0,
      signArr: [],
      checkArr: [],
      currentVC: null,
      currentTitle: '',
      checkStatus: -1,
      checkIndex: -1,
      checkStatusIndex: -1,
      hashStatus: -1,
      isCheckDone: false,
      showCheck: false,
      checkTitle: '印章校验',
      ruleValidationState: 0,
      identityContract: null,
      signCheckArr: [],
      signJsonArrCopy: [],
      sealsContract: null,
      signnewJsonArr: [],
      contractsContract: null,
      chainSignTime: '', // 签名上链时间
      efficacyTime: '', // VC吊销时间
      options: null
    }
  },
  components: {
    draggable
  },
  computed: {
  },
  filters: {
    formatDate (value, format) {
      if (!value) {
        return '--'
      }
      const d = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const year = d.getFullYear()
      let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
      return format
        .replace('YYYY', year)
        .replace('MM', month)
        .replace('DD', day)
        .replace('HH', hours)
        .replace('mm', min)
        .replace('ss', sec)
    }
  },
  created () {
    this.pageWidth = document.documentElement.clientWidth
    const that = this
    window.addEventListener('resize', function () {
      return (() => {
        that.pageWidth = document.documentElement.clientWidth
      })()
    })
    this.getData()
  },
  watch: {
    pageWidth: {
      handler (val) {
        this.ratio = val / this.imgWidth
        this.pageHeigt = this.imgHeight * this.ratio
      },
      deep: true
    },
    signCheckArr: {
      handler (newVal) {
        console.log('val', this.signCheckArr)
        this.signJsonArrCopy = JSON.parse(JSON.stringify(this.signCheckArr))
        this.signJsonArrCopy.forEach(item => {
          // console.log('校验Item', item)
          // let record = this.signList.filter(s => s.id === item.record.id)[0]
          // item.record = record
          item.checkTitle = item.vc.cptId === 10001 ? item.record.memberName + '(签字)' : item.record.memberName + '(盖章-' + item.record.signatureName + ')'
          // 校验VC格式
          item.checkFormatState = -1 // ICON
          item.checkFormatStatus = -1 // 颜色
          item.checkFormat = item.vc.cptId === 10001 ? '签名格式校验' : '签名格式校验'
          // 校验颁发者身份VC
          item.checkIssuerIdVCState = -1
          item.checkIssuerIdVCStatus = -1
          item.checkIssuerIdVC = item.vc.cptId === 10001 ? '签名人身份校验' : '盖章人身份校验'
          if (item.vc.cptId === 10002) {
            // 校验企业身份VC
            item.checkCompanyIdVCState = -1
            item.checkCompanyIdVCStatus = -1
            item.checkCompanyIdVC = '企业身份校验'
          }
          // 校验VC签名
          item.checkVCSignState = -1
          item.checkVCSignStatus = -1
          item.checkVCSign = item.vc.cptId === 10001 ? '签字签名校验' : '盖章签名校验'
          // 校验VC链上有效性
          item.checkVCSignValidState = -1
          item.checkVCSignValidStatus = -1
          item.checkVCSignValid = item.vc.cptId === 10001 ? '签字链上校验' : '盖章链上校验'
          item.chainSignTime = ''
          item.personalInfo = ''
          item.companyInfo = ''
        })
        this.signJsonArrCopy.reverse()
        console.log('校验：', this.signJsonArrCopy)
      },
      deep: true
    },
    fileDetail: {
      handler (val, oldVal) {
        this.getFilePreview()
      },
      deep: true
    }
  },
  mounted () {
    let _this = this
    document.onscroll = function (e) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      _this.currentPageIndex = Math.abs(Math.round(scrollTop / _this.imgHeight - 0.2))
    }
  },
  methods: {
    hidePhone,
    formatDate,
    back () {
      this.$router.back()
    },
    dotest () {
      console.log(web3.eth.accounts.sign('xxxx'))
    },
    getPopHeight () {
      if (this.versionList.length > 4) {
        return 4 * 61 + 54
      } else {
        return this.versionList.length * 61 + 54
      }
    },
    changeVersion (index) {
      if (index === 0) {
        this.fileDetail.recordId = ''
        this.fileDetail.signJson = ''
        this.signerArr = []
        this.loadPdf(this.fileDetail.fileUrl)
        this.signCheckArr = []
        this.currentIndex = 0
        this.currentTitle = ''
        this.show = false
        return
      }
      this.currentIndex = index
      let item = this.versionList[index - 1]
      this.fileDetail.signJson = item.signatureJson
      this.fileDetail.pdfUrl = item.pdfUrl
      this.fileDetail.recordId = item.id
      console.log('signJson', item.signatureJson)
      this.currentTitle = item.signatureId ? item.memberName + '(盖章)' : item.memberName + '(签字)'
      this.updateView(index - 1)
      this.signCheckArr = []
      this.deepCheckObj(this.fileDetail.recordId)
      this.show = false
    },
    async showModal (event, pindex, index, item) {
      this.chainSignTime = ''
      this.efficacyTime = ''
      this.personalEfficacyTime = ''
      this.companyEfficacyTime = ''
      let sign = this.signCheckArr.filter(sign => sign.vc.id === item.uuid)[0]
      let currentVC = JSON.parse(JSON.stringify(sign.vc))
      this.currentTxid = sign.record.txid
      this.currentVC = JSON.parse(JSON.stringify(currentVC))
      console.log(currentVC)
      this.fileHashObj = JSON.parse(localStorage.getItem('fileHashObj')) || {}
      // console.log(this.currentVC)
      var keys = Object.keys(this.fileHashObj)
      if (currentVC.cptId === 10001) {
        this.checkTitle = '签名校验'
        if (keys.indexOf(currentVC.claim.personVcHash) === -1) {
          await this.getFileByHash(currentVC.claim.personVcHash, 'PERSONAL_VC')
        }
        this.currentVC.personalInfo = JSON.parse(this.fileHashObj[currentVC.claim.personVcHash])
      } else if (currentVC.cptId === 10002) {
        this.checkTitle = '印章校验'
        if (keys.indexOf(currentVC.claim.companyVcHash) === -1) {
          await this.getFileByHash(currentVC.claim.companyVcHash, 'COMPANY_VC')
        }
        if (keys.indexOf(currentVC.claim.companyVcHash) === -1) {
          await this.getFileByHash(currentVC.claim.personVcHash, 'PERSONAL_VC')
        }
        // console.log(this.fileHashObj)
        this.currentVC.personalInfo = JSON.parse(this.fileHashObj[currentVC.claim.personVcHash])
        this.currentVC.companyInfo = JSON.parse(this.fileHashObj[currentVC.claim.companyVcHash])
      }
      this.showCheck = true
      this.ruleValidationState = 0
      await this.sleep(1000)
      // this.ruleValidationState = 2
      let res = await this.doCheckSign(currentVC, this.currentVC)
      if (res) {
        this.ruleValidationState = 1
      } else {
        this.ruleValidationState = 2
      }
      this.showCheck = true
    },
    async getFileByHash (hash, type) {
      fileHashQuery({
        hash: hash,
        hashType: type
      }).then(res => {
        // console.log('获取vc:', res.data)
        var keys = Object.keys(this.fileHashObj)
        if (keys.indexOf(hash) === -1) {
          this.fileHashObj[hash] = res.data
        }
        // console.log('fileHashObj1:', this.fileHashObj)
        localStorage.setItem('fileHashObj', JSON.stringify(this.fileHashObj))
      })
    },
    change () {
      this.show = true
    },
    getData () {
      console.log(this.$route)
      let s = this.$route.params.id.split('&')
      shareFileDetail({
        shorturl: s[0],
        code: s[1]
      }).then(res => {
        this.fileDetail = res.data
        // this.deepCheckObj()
        this.getFilePreview()
        this.getSignRecord()
        // if (this.fileDetail.signJson) {
        //   this.versionList = []
        // }
      })
    },
    deepCheckObj (recordId) {
      let signRecordList = JSON.parse(JSON.stringify(this.fileDetail.signRecordList))
      let record
      if (!recordId) {
        record = signRecordList[signRecordList.length - 1]
      } else {
        record = signRecordList.filter(item => item.id === recordId)[0]
      }
      // let record = signRecordList[signRecordList.length - 1]
      let signJson = JSON.parse(record.signatureJson)
      this.signCheckArr.push({
        record: record,
        vc: signJson
      })
      if (record.parentId !== 0) {
        this.deepCheckObj(record.parentId)
      }
    },
    getFilePreview () {
      let signRecordList = this.fileDetail.signRecordList
      signRecordList = signRecordList.filter(item => item.pdfUrl.indexOf('.pdf') !== -1)
      signRecordList = signRecordList.sort((a, b) => {
        return a.id - b.id
      })
      signRecordList.forEach(item => {
        let signJson = JSON.parse(item.signatureJson)
        var keys = Object.keys(this.fileHashObj)
        if (signJson.cptId === 10001) {
          if (keys.indexOf(signJson.claim.personVcHash) === -1) {
            this.getFileByHash(signJson.claim.personVcHash, 'PERSONAL_VC')
          }
        } else if (signJson.cptId === 10002) {
          if (keys.indexOf(signJson.claim.companyVcHash) === -1) {
            this.getFileByHash(signJson.claim.companyVcHash, 'COMPANY_VC')
            this.getFileByHash(signJson.claim.personVcHash, 'PERSONAL_VC')
          }
        }
      })
    },
    loadPdf (pdfUrl) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        message: '加载中,请稍候...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true
      })
      this.loadingTask = pdfjs.getDocument({
        url: pdfUrl,
        cMapUrl: '/cmaps/',
        cMapPacked: true
      })
      // this.loadTask = vuePdf.createLoadingTask(pdfUrl)
      console.log(this.loadingTask)
      const pdf = this.loadingTask.promise
      console.log(pdf)
      this.pageNums = 0
      pdf.then(res => {
        this.pageNums = res.numPages
        if (this.pageNums > 0) {
          this.$store.commit('setUrlList', this.pageNums)
        }
        res.getData().then(res => {
          // console.log('pdfData', res, this.loadPdfObj)
          this.pdfData = res
          //   this.$store.commit('setPdfData', this.pdfData)
        })
        this.loadPage(0, 1, res, 1)
      })
    },
    getCheckHeight () {
      if (this.signJsonArrCopy.length > 3) {
        let h = 0
        this.signJsonArrCopy.forEach((item, index) => {
          if (index < 3) {
            if (item.vc.cptId === 10001) {
              h += 142.19 + 8 * 2 + 15
            } else {
              h += 190.17 + 8 * 2 + 15
            }
          }
        })
        return h
      } else {
        let arr = this.signJsonArrCopy.filter(item => item.vc.cptId === 10001)
        return (142.19 + 8 * 2 + 15) * arr.length + (190.17 + 8 * 2 + 15) * (this.signJsonArrCopy.length - arr.length)
      }
    },
    drawImage (maxWidth, maxHeight, objImg) {
      var hRatio
      var wRatio
      var Ratio = 1
      var w = objImg.width
      var h = objImg.height
      wRatio = maxWidth / w
      hRatio = maxHeight / h
      if (maxWidth === 0 && maxHeight === 0) {
        Ratio = 1
      } else if (maxWidth === 0) { //
        if (hRatio < 1) Ratio = hRatio
      } else if (maxHeight === 0) {
        if (wRatio < 1) Ratio = wRatio
      } else if (wRatio < 1 || hRatio < 1) {
        Ratio = (wRatio <= hRatio ? wRatio : hRatio)
      }
      if (Ratio < 1) {
        w = w * Ratio
        h = h * Ratio
      }
      objImg.height = h
      objImg.width = w
      return {
        h,
        wRatio,
        hRatio,
        w,
        Ratio
      }
    },
    computedWidth (res) {
      this.imgWidth = Math.ceil(res._pageInfo.view[2]) * this.pix
      this.imgHeight = Math.ceil(res._pageInfo.view[3]) * this.pix
      console.log('原始', this.imgWidth, this.imgHeight)
      if (this.imgWidth > this.imgHeight) {
        this.isShort = true
      }
      let width = document.documentElement.clientWidth
      if (this.imgWidth > width) {
        let obj = this.drawImage(width, 0, {
          width: this.imgWidth,
          height: this.imgHeight
        })
        this.imgHeight = obj.h
        this.imgWidth = width
      }
      this.$store.commit('setImgWidth', this.imgWidth)
      this.$store.commit('setImgHeight', this.imgHeight)
    },
    createElement (res, i, index) {
      if (i === 0) {
        this.computedWidth(res)
      }
      console.log(res)
      let page = document.getElementById('item-page_' + i)
      let pageImg = document.getElementById('page-img-' + i)
      if (page === null) return
      let child = document.createElement('div')
      child.className = 'children'
      let canvas = document.createElement('canvas')
      let iIndex = i + '-' + index
      let iThisIndex = i + '-' + this.ranNum
      console.log(iIndex, iThisIndex)
      if (iIndex !== iThisIndex) return
      let canvasId = 'canvas-' + i + '-' + index
      let newCanvas = document.getElementById(canvasId)
      if (newCanvas) {
        return
      }
      canvas.id = canvasId
      let context = canvas.getContext('2d')
      let width = document.documentElement.clientWidth
      const viewport = res.getViewport({ scale: 2 })
      canvas.width = viewport.width
      canvas.height = viewport.height
      let obj = this.drawImage(width, 0, {
        width: viewport.width,
        height: viewport.height
      })
      canvas.style.width = obj.w + 'px'
      canvas.style.height = obj.h + 'px'
      console.log('obj', obj, viewport)
      this.imgHeight = obj.h
      this.$store.commit('setImgWidth', width)
      this.$store.commit('setImgHeight', this.imgHeight)
      this.signRatio = width / 800
      console.log(this.signRatio)
      const renderContext = {
        canvasContext: context,
        viewport: viewport
      }
      page.appendChild(canvas)
      res.render(renderContext)
      this.$toast.clear()
      let loadingPage = document.getElementById('loading-page_' + i)
      page.removeChild(loadingPage)
      // pdfPreview.appendChild(page)
    },
    loadPage (num, total, res, time) {
      //   if (total < this.pageNums) {
      //     total = this.pageNums
      //   }
      setTimeout(() => {
        for (let i = num + 1; i <= total; i++) {
          if (i > this.pageNums) return
          res.getPage(i).then(result => {
            console.log(this.fileDetail.currentIndex)
            if (!this.fileDetail.currentIndex) {
              this.fileDetail.currentIndex = 0
            }
            if (!this.ranNum) {
              this.ranNum = 0
            }
            this.createElement(result, i - 1, this.fileDetail.currentIndex)
            this.loadingStatus = false
            this.fillData()
            let iIndex = i + '-' + this.fileDetail.currentIndex
            let iThisIndex = i + '-' + this.ranNum
            if (iIndex !== iThisIndex) return
            if (i === this.pageNums) {
              return
            }
            if (i === total) {
              let sectime = 1
              if (i > 20) {
                sectime = 1
              } else {
                sectime = 500
              }
              this.loadPage(total, total + 1, res, sectime)
            }
          })
        }
      }, time)
    },
    fillData () {
      clearInterval(this.timer)
      this.$store.commit('setSignerArr', [])
      this.$store.commit('setRidingArr', [])
      this.$store.commit('setDateArr', [])
      this.$store.commit('setSignatureArr', [])
      // if (!this.fileDetail.signJson) return
      this.signArr = [] // 所有已签名的渲染数据 signJson递归获取
      this.signerArr = [] // 所有的签字
      this.signatureArr = [] // 所有的签章
      this.dateArr = [] // 所有的日期
      this.ridingArr = []
      let signJson = []
      // console.log('签名数据：', JSON.parse(this.fileDetail.signJson))
      let recordId = this.fileDetail.recordId
      this.signJsonArr = []
      let isOld = false
      console.log('recordId', recordId)
      if (!recordId) {
        if (this.fileDetail.signJson) {
          this.deepDraftObj(this.fileDetail.signJson)
        }
      } else {
        this.deepObj(recordId)
        isOld = true
      }
      this.signnewJsonArr = this.signJsonArr.reverse()
      signJson = JSON.parse(JSON.stringify(this.signJsonArr)).flat()
      // console.log('signJson', signJson, this.signJsonArr)
      let ridingList = signJson.filter(item => item.signType === 7)
      // console.log(ridingList)
      ridingList.forEach((sig, index) => {
        // 预览的时候禁止拖动
        if (this.type === 3) {
          sig.showDraggable = true
        }
        // 签署的时候禁止拖动别人的
        if (this.type === 2) {
          sig.showDraggable = true
        }
        if (isOld) {
          sig.show = true
          sig.old = true
        }
      })
      this.ridingArrStatus = ridingList.filter(item => !item.old).length
      if (ridingList.length) {
        this.ridingArr = ridingList
        if (!isOld) {
          this.showArea = true
        }
        if (this.type === 3) {
          this.showArea = false
        }
      } else {
        this.ridingArr = []
      }
      this.$store.commit('setRidingArr', this.ridingArr)
      for (let i = 0; i < this.pageNums; i++) {
        let signerList = signJson.filter(item => item.p === i && item.signType === 4)
        let signatureList = signJson.filter(item => item.p === i && item.signType === 6)
        let dateList = signJson.filter(item => item.p === i && item.signType === 5)
        signerList.forEach(sig => {
          // 预览的时候禁止拖动
          if (this.type === 3) {
            sig.showDraggable = true
          }
          // 签署的时候禁止拖动别人的
          if (this.type === 2) {
            sig.showDraggable = true
          }
          if (isOld) {
            sig.show = true
            sig.old = true
          }
        })
        signatureList.forEach(sig => {
          // 预览的时候禁止拖动
          if (this.type === 3) {
            sig.showDraggable = true
          }
          // 签署的时候禁止拖动别人的
          if (this.type === 2) {
            sig.showDraggable = true
          }
          if (isOld) {
            sig.show = true
            sig.old = true
          }
        })
        dateList.forEach(sig => {
          // 预览的时候禁止拖动
          if (this.type === 3) {
            sig.showDraggable = true
          }
          // 签署的时候禁止拖动别人的
          if (this.type === 2) {
            sig.showDraggable = true
          }
          if (isOld) {
            sig.show = true
            sig.old = true
          }
        })
        this.signerArr[i] = signerList
        // this.dateArr[i] = dateList
        this.signatureArr[i] = signatureList
        console.log(signerList)
        // this.$store.commit('setSignerArr', this.signerArr)
        // this.$store.commit('setDateArr', this.dateArr)
        // this.$store.commit('setSignatureArr', this.signatureArr)
        this.$forceUpdate()
      }
    },
    getSignRecord () {
      this.versionList = this.fileDetail.signRecordList.filter(item => item.contractStatus === 2 && item.pdfUrl)
      this.versionList = this.versionList.sort(function (a, b) {
        return b.id < a.id ? 1 : -1
      })
      if (this.versionList.length) {
        this.currentIndex = this.versionList.length
        console.log('versionList', this.versionList)
        this.changeVersion(this.currentIndex)
        console.log('currentIndex', this.currentIndex)
      } else {
        this.changeVersion(0)
      }
    },
    deepDraftObj (signJson) {
      let layout = JSON.parse(signJson)
      this.signJsonArr.push(...layout)
      this.signJsonArr.forEach(item => {
        if (!item) return
        if (item.x) {
          item.x = item.x * this.imgWidth
        }
        item.y = this.imgHeight - (item.y * this.imgHeight) - (item.h * this.imgHeight)
        item.w = item.w * this.imgWidth
        item.h = item.h * this.imgHeight
      })
    },
    deepObj (recordId) {
      let signRecordList = JSON.parse(JSON.stringify(this.fileDetail.signRecordList))
      let record = signRecordList.filter(item => item.id === recordId)[0]
      let signJson = JSON.parse(record.signatureJson)
      let uuid = signJson.id
      let layout = JSON.parse(signJson.claim.layout)
      let ridArr = layout.filter(item => item.signType === 7)
      // console.log(ridArr)
      ridArr.forEach(l => {
        l.coordinate.forEach((c, index) => {
          let obj = {
            uuid: uuid,
            imgHash: l.imgHash,
            y: this.imgHeight - (c.y * this.imgHeight) - (c.h * this.imgHeight),
            w: c.w * this.imgWidth,
            h: c.h * this.imgHeight,
            signType: l.signType
          }
          this.signJsonArr.push(obj)
        })
      })
      for (let p = 0; p < this.pageNums; p++) {
        // console.log(layout)
        layout.forEach(l => {
          if (l.signType !== 7) {
            l.coordinate.forEach(c => {
              if (c.p.indexOf(p) !== -1) {
                let obj = {
                  uuid: uuid,
                  imgHash: l.imgHash,
                  x: c.x * this.imgWidth,
                  y: this.imgHeight - (c.y * this.imgHeight) - (c.h * this.imgHeight),
                  w: c.w * this.imgWidth,
                  h: c.h * this.imgHeight,
                  p: p,
                  signType: l.signType
                }
                this.signJsonArr.push(obj)
              }
            })
          }
        })
      }
      if (record.parentId !== 0) {
        this.deepObj(record.parentId)
      }
    },
    deepAllSign (signJson) {
      if (signJson.sealsClaim !== null && Object.values(signJson.sealsClaim).length) {
        this.signArr.push(Object.values(signJson.sealsClaim).flat())
      }
      if (signJson.nestSignature != null && (signJson.nestSignature.sealsClaim !== null || signJson.nestSignature.sealsClaim !== undefined)) {
        if (signJson.nestSignature.sealsClaim && Object.values((signJson.nestSignature.sealsClaim)).length) {
          this.deepAllSign(signJson.nestSignature)
        }
      }
    },
    getDid (did, isAddress) {
      did = did.replace('did:gid:', '')
      return isAddress ? '0x' + did : did
    },
    getName (item) {
      // let sealsClaimArr = item.sealsClaim[0]
      // let signer = sealsClaimArr[0]
      return item.signatureId ? item.memberName + '(盖章)' : item.memberName + '(签字)'
    },
    getVCVildeTime (currentVC) {
      if (this.efficacyTime === '0') {
        return this.formatDate(currentVC.signerVC.issuanceDate) + '至' + this.formatDate(currentVC.signerVC.expirationDate)
      } else {
        return this.formatDate(currentVC.signerVC.issuanceDate) + '至' + this.formatDate(this.efficacyTime * 1000)
      }
      // formatDate(currentVC.signerVC.issuanceDate)}} 至 {{formatDate(currentVC.signerVC.expirationDate)
    },
    closePop () {
      this.showCheck = false
    },
    // 验签用的claim排序算法
    vcSaltSha3 (claim, salt) {
      var newkeys = Object.keys(claim).sort()
      var newObj = {}
      for (var i = 0; i < newkeys.length; i++) {
        if (salt[newkeys[i]] !== 0 || salt[newkeys[i]] !== '0') {
          newObj[newkeys[i]] = storm3.utils.soliditySha3({ t: 'string', v: claim[newkeys[i]].toString() + salt[newkeys[i]] })
        } else {
          newObj[newkeys[i]] = claim[newkeys[i]]
        }
      }
      return newObj
    },
    getVCSignature (data) {
      let signatureJson = JSON.parse(JSON.stringify(this.objKeySort(data)))
      let ssha3 = this.vcSaltSha3(signatureJson.claim, signatureJson.proof.salt)
      signatureJson.claim = JSON.stringify(ssha3)
      signatureJson.proof.salt = null
      let signHash = storm3.utils.sha3(JSON.stringify(signatureJson))
      return signHash
    },
    async check () {
      this.checkStatus = 0
      this.isCheckDone = false
      this.ruleValidationState = -1
      this.hashStatus = -1
      this.checkModal = true
      this.signJsonArrCopy.forEach(item => {
        // 校验VC格式
        item.checkFormatStatus = -1
        item.checkFormatState = -1
        item.checkIssuerIdVCStatus = -1
        item.checkIssuerIdVCState = -1
        if (item.vc.cptId === 10002) {
          // 校验企业身份VC
          item.checkCompanyIdVCStatus = -1
          item.checkCompanyIdVCState = -1
        }
        // 校验VC签名
        item.checkVCSignStatus = -1
        item.checkVCSignState = -1
        // 校验VC链上有效性
        item.checkVCSignValidStatus = -1
        item.checkVCSignValidState = -1
      })
      await this.doChecFileHash()
      if (this.currentIndex === 0) {
        this.checkStatus = 1
        return
      }
      console.log('signJsonArrCopy', this.signJsonArrCopy)
      for (let i = 0; i < this.signJsonArrCopy.length; i++) {
        let sign = JSON.parse(JSON.stringify(this.signJsonArrCopy[i]))
        let currentVC = JSON.parse(JSON.stringify(sign.vc))
        let currentVCInfo = JSON.parse(JSON.stringify(currentVC))
        this.fileHashObj = JSON.parse(localStorage.getItem('fileHashObj')) || {}
        console.log(currentVCInfo)
        console.log(currentVC)
        var keys = Object.keys(this.fileHashObj)
        if (currentVC.cptId === 10001) {
          if (keys.indexOf(currentVC.claim.personVcHash) === -1) {
            await this.getFileByHash(currentVC.claim.personVcHash, 'PERSONAL_VC')
          }
          currentVCInfo.personalInfo = JSON.parse(this.fileHashObj[currentVC.claim.personVcHash])
          this.signJsonArrCopy.personalInfo = currentVCInfo.personalInfo
        } else if (currentVC.cptId === 10002) {
          this.checkTitle = '印章校验'
          console.log(keys, currentVC.claim.companyVcHash, currentVC.claim.companyVcHash)
          if (keys.indexOf(currentVC.claim.companyVcHash) === -1) {
            await this.getFileByHash(currentVC.claim.companyVcHash, 'COMPANY_VC')
          }
          if (keys.indexOf(currentVC.claim.companyVcHash) === -1) {
            await this.getFileByHash(currentVC.claim.personVcHash, 'PERSONAL_VC')
          }
          console.log(this.fileHashObj, currentVC.claim.personVcHash, this.fileHashObj[currentVC.claim.personVcHash])
          currentVCInfo.personalInfo = JSON.parse(this.fileHashObj[currentVC.claim.personVcHash])
          currentVCInfo.companyInfo = JSON.parse(this.fileHashObj[currentVC.claim.companyVcHash])
          this.signJsonArrCopy.personalInfo = currentVCInfo.personalInfo
          this.signJsonArrCopy.companyInfo = currentVCInfo.companyInfo
        }
        console.log(currentVCInfo)
        let res = await this.doBathCheckSign(i, currentVC, currentVCInfo)
        // let res = await this.doCheckSign(i)
        this.signJsonArrCopy = JSON.parse(JSON.stringify(this.signJsonArrCopy))
        console.log('已完成', this.signJsonArrCopy[i])
        if (!res) {
          this.checkStatus = 2
          break
        }
        if (i === this.signJsonArrCopy.length - 1) {
          this.isCheckDone = true
          this.checkStatus = 1
        }
      }
    },
    async sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time))
    },
    async doChecFileHash () {
      let _this = this
      this.ruleValidationState = 0
      return new Promise(function (resolve, reject) {
        setTimeout(() => {
          _this.ruleValidationState = 1
          _this.hashStatus = 1
          resolve()
        }, 500)
      })
    },
    async checkVCValid (hash, hashType) {
      let _this = this
      return new Promise(function (resolve, reject) {
        // 根据hash和类型查询状态(-1不存在或失效，0有效，>0其他为失效时间)
        queryStatusByHash({
          hash: hash,
          hashType: hashType
        }).then(res => {
          resolve(res.data)
        })
      })
    },
    getFileHash (originPdfHash) {
      if (originPdfHash.length < 64) {
        return storm3.utils.utf8ToHex(originPdfHash)
      } else if (originPdfHash.indexOf('0x') !== -1) {
        return originPdfHash
      }
      return '0x' + originPdfHash
    },
    async doBathCheckSign (index, VC, currentVC) {
      // 校验签名格式
      let res = await this.doCheckFormat(VC)
      if (!res) {
        this.signJsonArrCopy[index].checkFormatState = 2
        this.signJsonArrCopy[index].checkFormatStatus = 0
        return false
      }
      this.signJsonArrCopy[index].checkFormatState = 1
      this.signJsonArrCopy[index].checkFormatStatus = 1
      // ==========分割线===========================================
      // 检验身份VC 检验两次一次签名校验，一次有效性校验
      this.signJsonArrCopy = JSON.parse(JSON.stringify(this.signJsonArrCopy))
      // 校验个人身份VC签名
      let res0 = await this.doCheckSignItem(currentVC.personalInfo, 'idVC')
      if (!res0) {
        this.signJsonArrCopy[index].checkIssuerIdVCState = 2
        this.signJsonArrCopy[index].checkIssuerIdVCStatus = 0
        return false
      }
      // 校验个人身份VC是否有效
      let res1 = await this.checkVCValid(VC.claim.personVcHash, 'PERSONAL_VC')
      if (res1 === -1) {
        this.signJsonArrCopy[index].checkIssuerIdVCState = 2
        this.signJsonArrCopy[index].checkIssuerIdVCStatus = 0
        return false
      }
      this.signJsonArrCopy[index].checkIssuerIdVCState = 1
      this.signJsonArrCopy[index].checkIssuerIdVCStatus = 1
      // ==========分割线===========================================
      if (VC.claim.companyVcHash) {
        // 校验企业身份VC签名
        let res01 = await this.doCheckSignItem(currentVC.companyInfo, 'idVC')
        if (!res01) {
          this.signJsonArrCopy[index].checkCompanyIdVCState = 2
          this.signJsonArrCopy[index].checkCompanyIdVCStatus = 0
          return false
        }
        // 校验企业身份VC是否有效
        let res11 = await this.checkVCValid(VC.claim.companyVcHash, 'COMPANY_VC')
        if (res11 === -1) {
          this.signJsonArrCopy[index].checkCompanyIdVCState = 2
          this.signJsonArrCopy[index].checkCompanyIdVCStatus = 0
          return false
        }
        this.signJsonArrCopy[index].checkCompanyIdVCState = 1
        this.signJsonArrCopy[index].checkCompanyIdVCStatus = 1
      }
      // ==========分割线===========================================
      // 校验合同签署VC签名
      let res2 = await this.doCheckSignItem(VC, 'VC')
      if (!res2) {
        this.signJsonArrCopy[index].checkVCSignState = 2
        this.signJsonArrCopy[index].checkVCSignStatus = 0
        return false
      }
      this.signJsonArrCopy[index].checkVCSignState = 1
      this.signJsonArrCopy[index].checkVCSignStatus = 1
      // ==========分割线===========================================
      if (VC.cptId === 10001) {
        console.log('dadadasdadas：', VC)
        let res3 = await this.doCheckSignItem(VC, 'validPersonal')
        console.log(res3)
        this.chainSignTime = res3
        if (res3 === '0') {
          this.signJsonArrCopy[index].checkVCSignValidState = 2
          this.signJsonArrCopy[index].checkVCSignValidStatus = 0
          this.signJsonArrCopy[index].chainSignTime = ''
          return false
        }
        this.signJsonArrCopy[index].checkVCSignValidState = 1
        this.signJsonArrCopy[index].checkVCSignValidStatus = 1
        this.signJsonArrCopy[index].chainSignTime = res3
      }
      // ==========分割线===========================================
      if (VC.cptId === 10002) {
        let res4 = await this.doCheckSignItem(VC, 'validcompany')
        if (res4 === '0') {
          this.signJsonArrCopy[index].checkVCSignValidState = 2
          this.signJsonArrCopy[index].checkVCSignValidStatus = 0
          this.signJsonArrCopy[index].chainSignTime = ''
          return false
        }
        this.signJsonArrCopy[index].checkVCSignValidState = 1
        this.signJsonArrCopy[index].checkVCSignValidStatus = 1
        this.signJsonArrCopy[index].chainSignTime = res4
      }
      return true
    },
    async doCheckSign (VC, currentVC) {
      // 校验个人身份VC签名
      let res0 = await this.doCheckSignItem(currentVC.personalInfo, 'idVC')
      if (!res0) {
        return false
      }
      // 校验个人身份VC是否有效
      let res1 = await this.checkVCValid(VC.claim.personVcHash, 'PERSONAL_VC')
      if (res1 === -1) {
        return false
      }
      this.personalEfficacyTime = res1
      if (VC.claim.companyVcHash) {
        // 校验企业身份VC签名
        let res01 = await this.doCheckSignItem(currentVC.companyInfo, 'idVC')
        if (!res01) {
          return false
        }
        // 校验企业身份VC是否有效
        let res11 = await this.checkVCValid(VC.claim.companyVcHash, 'COMPANY_VC')
        if (res11 === -1) {
          return false
        }
        this.personalEfficacyTime = res11
      }
      // 校验合同签署VC签名
      let res2 = await this.doCheckSignItem(VC, 'VC')
      if (!res2) {
        return false
      }
      if (VC.cptId === 10001) {
        let res3 = await this.doCheckSignItem(VC, 'validPersonal')
        this.chainSignTime = res3
        if (res3 === '0') {
          return false
        }
      }
      if (VC.cptId === 10002) {
        let res4 = await this.doCheckSignItem(VC, 'validcompany')
        this.chainSignTime = res4
        if (res4 === '0') {
          return false
        }
      }
      return true
    },
    doCheckFormat (VC) {
      if (Object.prototype.toString.call(VC) !== '[object Object]') {
        return false
      }
      if (!VC.hasOwnProperty('context') ||
        !VC.hasOwnProperty('id') ||
        !VC.hasOwnProperty('cptId') ||
        !VC.hasOwnProperty('issuer') ||
        !VC.hasOwnProperty('issuanceDate') ||
        !VC.hasOwnProperty('expirationDate') ||
        !VC.hasOwnProperty('context')) {
        return false
      }
      if (VC.cptId === 10001) {
        if (!VC.claim.hasOwnProperty('layout') ||
          !VC.claim.hasOwnProperty('originPdfHash') ||
          !VC.claim.hasOwnProperty('personVcHash') ||
          !VC.claim.hasOwnProperty('personDid') ||
          !VC.claim.hasOwnProperty('personSeal') ||
          !VC.claim.hasOwnProperty('previousSignHash')) {
          return false
        }
      }
      if (VC.cptId === 10002) {
        if (!VC.claim.hasOwnProperty('layout') ||
          !VC.claim.hasOwnProperty('originPdfHash') ||
          !VC.claim.hasOwnProperty('personVcHash') ||
          !VC.claim.hasOwnProperty('personDid') ||
          !VC.claim.hasOwnProperty('companyVcHash') ||
          !VC.claim.hasOwnProperty('companyDid') ||
          !VC.claim.hasOwnProperty('previousSignHash') ||
          !VC.claim.hasOwnProperty('companySeal')) {
          return false
        }
      }
      return true
    },
    getPublicKey (publicKey) {
      // 部分语言生成的公钥可能会包含一个'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8A'这样的开头，所以此处进行了替换成空处理
      publicKey = publicKey.replace('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8A', '')
      // 如果传入的公钥地址已经是去除了-----BEGIN RSA PUBLIC KEY-----和换行符的字符串，直接转Buffer
      if (publicKey.indexOf('\n') === -1) {
        return publicKey
      }
      // 如果传入的公钥地址没有做任何处理，此处重组后转Buffer
      const tmpArr = publicKey.split('\n')
      for (let i = tmpArr.length - 1; i >= 0; i--) {
        if (tmpArr[i].indexOf('---') === -1) {
          tmpArr.pop()
        } else {
          break
        }
      }
      tmpArr.pop()
      tmpArr.shift()
      publicKey = tmpArr.join('')
      return publicKey
    },
    async doCheckSignItem (VC, type) {
      let _this = this
      if (type === 'idVC') {
        return new Promise(function (resolve, reject) {
          let publicKey = chainmaker.getOrgPem()
          if (VC.proof.publicKey) {
            publicKey = Base64.decode(VC.proof.publicKey)
          }
          publicKey = _this.getPublicKey(publicKey)
          let result = chainmaker.verifyVC(VC, VC.proof.signatureValue, publicKey)
          let address = chainmaker.publicKeyToAddress(publicKey)
          console.log('publicKey', publicKey)
          console.log('idVC', VC, address)
          console.log('signatureValue', VC.proof.signatureValue)
          if (result && VC.proof.type === 'SHA256withRSA' && address.replace('0x', '').toUpperCase() === VC.proof.creator.split(':').pop().toUpperCase()) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      } else if (type === 'VC') {
        return new Promise(function (resolve, reject) {
          let publicKey = VC.proof.publicKey ? Base64.decode(VC.proof.publicKey) : VC.claim.publicKey
          publicKey = _this.getPublicKey(publicKey)
          let address = chainmaker.publicKeyToAddress(publicKey)
          let result = chainmaker.verifyVC(VC, VC.proof.signatureValue, publicKey)
          console.log('VC', VC, address)
          if (result && VC.proof.type === 'SHA256withRSA' && address.replace('0x', '').toUpperCase() === VC.proof.creator.split(':').pop().toUpperCase()) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      } else if (type === 'validPersonal') {
        return new Promise(function (resolve, reject) {
          let signVC = JSON.parse(JSON.stringify(VC))
          let _fileHash = _this.getFileHash(signVC.claim.originPdfHash)
          let _signHash = _this.getVCSignature(signVC)
          let _signAddr = '0x' + signVC.proof.creator.split(':').pop()
          let raw = _fileHash + _signHash.replace('0x', '') + _signAddr.replace('0x', '')
          console.log('_fileHash', _fileHash)
          let signHash = storm3.utils.sha3(raw)
          let result = utils.filter(item => item.name === 'contractMap')
          let inputData = '0x' + result[0].methodId + web3.eth.abi.encodeParameters(result[0].params, [signHash]).replace('0x', '')
          console.log(inputData)
          let param = {
            contractNameHash: VC.claim.personSeal,
            method: '0x' + result[0].methodId,
            param: Base64.encode(inputData)
          }
          console.log(param)
          chainSimpleQuery(param).then(resp => {
            console.log('查询签字VC上链时间', resp)
            let respObj = JSON.parse(resp.data)
            let time = chainmaker.getChainTime(respObj.contractResult.result)
            resolve(time)
          }).catch(err => {
            reject(err)
          })
        })
      } else if (type === 'validcompany') {
        return new Promise(function (resolve, reject) {
          let signVC = JSON.parse(JSON.stringify(VC))
          let _fileHash = _this.getFileHash(signVC.claim.originPdfHash)
          let _signHash = _this.getVCSignature(signVC)
          let _signAddr = '0x' + signVC.proof.creator.split(':').pop()
          console.log('_fileHash', _fileHash)
          let raw = _fileHash + _signHash.replace('0x', '') + _signAddr.replace('0x', '')
          let signHash = storm3.utils.sha3(raw)
          let result = utils.filter(item => item.name === 'contractMap')
          let inputData = '0x' + result[0].methodId + web3.eth.abi.encodeParameters(result[0].params, [signHash]).replace('0x', '')
          console.log(inputData)
          let param = {
            contractNameHash: VC.claim.companySeal,
            method: '0x' + result[0].methodId,
            param: Base64.encode(inputData)
          }
          console.log(param)
          chainSimpleQuery(param).then(resp => {
            console.log('查询盖章VC上链时间', resp)
            let respObj = JSON.parse(resp.data)
            let time = chainmaker.getChainTime(respObj.contractResult.result)
            resolve(time)
          }).catch(err => {
            reject(err)
          })
        })
      }
    },
    recoverSignature (signItem, isVc) {
      let signJson = JSON.parse(JSON.stringify(signItem))
      let messageHash = ''
      let signature = isVc ? signJson.signerVC.proof.signature : signJson.proof.signature
      let creator = isVc ? signJson.signerVC.proof.creator : signJson.proof.creator
      if (isVc) {
        signJson.signerVC.proof = null
        let ssha3 = this.vcSha3(signJson.signerVC.claim)
        signJson.signerVC.claim = ssha3
        messageHash = storm3.utils.sha3(JSON.stringify(this.objKeySort(signJson.signerVC)))
      } else {
        signJson.proof = null
        messageHash = storm3.utils.sha3(storm3.utils.hexToBytes(storm3.utils.sha3(JSON.stringify(this.objKeySort(signJson)))))
      }
      let vrsStr = storm3.utils.bytesToHex(Array.from(Base64.toUint8Array(signature))).replace('0x', '')
      let v = '0x' + vrsStr.substring(0, 2)
      let r = '0x' + vrsStr.substring(2, 64 + 2)
      let s = '0x' + vrsStr.substring(64 + 2, vrsStr.length)
      let recoverDid = isVc ? web3.eth.accounts.recover(storm3.utils.sha3(storm3.utils.hexToBytes(messageHash)), v, r, s, true) : web3.eth.accounts.recover(messageHash, v, r, s)
      if (recoverDid.replace('0x', '').toUpperCase() === creator.split(':')[2].toUpperCase()) {
        // let aa = isVc ? '身份验证成功' : '签名验证成功'
        return true
      } else {
        // let aa = isVc ? '身份验证失败' : '签名验证失败'
        return false
      }
    },
    vcSha3 (obj) { // 排序的函数
      var newkey = Object.keys(obj).sort()
      var value = ''
      for (var i = 0; i < newkey.length; i++) {
        value += newkey[i] + storm3.utils.sha3(obj[newkey[i]])
      }
      return value
    },
    objKeySort (obj) { // 排序的函数
      var newkey = Object.keys(obj).sort() // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
      var newObj = {} // 创建一个新的对象，用于存放排好序的键值对
      for (var i = 0; i < newkey.length; i++) { // 遍历newkey数组
        if (Object.prototype.toString.call(obj[newkey[i]]) === '[object Object]') { // 如果value是对象递归sort
          obj[newkey[i]] = this.objKeySort(obj[newkey[i]])
        } else if (Array.isArray(obj[newkey[i]])) { // 如果value是数组递归sort
          for (var j = 0; j < obj[newkey[i]].length; j++) {
            obj[newkey[i]][j] = this.objKeySort(obj[newkey[i]][j])
          }
        }
        newObj[newkey[i]] = obj[newkey[i]] // 向新创建的对象中按照排好的顺序依次增加键值对
      }
      return newObj // 返回排好序的新对象
    },
    updateView (index) {
      if (!this.versionList.length) {
        return
      }
      this.loadPdf(this.versionList[index].pdfUrl)
    }
  }
}
</script>

<style scoped lang="less">
.van-nav-bar {
  position: fixed;
  top: 0;
  width: 100%;
}
.check {
  min-height: 100vh;
  background: rgb(238, 238, 238);
  .van-nav-bar {
    z-index: 999;
  }
  .contain {
    padding-top: 10px;
    margin-bottom: 40px;
    background: rgb(238, 238, 238);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    .pagenums {
      position: fixed;
      right: 10px;
      z-index: 10;
      font-size: 14px;
      background: #000;
      border-radius: 10px;
      padding-left: 4px;
      padding-right: 4px;
      color: #fff;
    }
    .cell {
      width: 100%;
      padding-bottom: 10px;
      position: relative;
      .loading-page {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        -webkit-user-drag: none;
        width: 100%;
        height: 100%;
      }
      .cellarea {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
        .signItem {
          border: 1px dashed #276ef9;
          border-radius: 5px;
        }
        .movTime {
          text-align: center;
          width: 100%;
          border-radius: 5px;
        }
        .movUrl {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .movback {
          border-radius: 10rpx;
          position: absolute;
          text-align: center;
          width: 100%;
          height: 100%;
          top: 0;
          opacity: 0.3;
        }
        .movcycle {
          text-align: center;
          font-size: 28rpx;
          border-radius: 50% !important;
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: rgba(255, 255, 255, 100);
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    text-align: center;
    font-family: Arial;
    position: fixed;
    z-index: 100;
    bottom: 0;
    border-top: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    .left {
      color: #e60000;
      padding: 0 20px;
      flex: 1;
      display: flex;
      justify-content: space-between;
    }
    .right {
      width: 100px;
      background-color: #e60000;
      color: #ffffff;
    }
  }
  .poppadding {
    bottom: constant(safe-area-inset-bottom) !important;
    bottom: env(safe-area-inset-bottom) !important;
    overflow-y: initial !important;
  }
  .popView {
    max-height: 250px;
    overflow: auto;
    .version {
      padding: 0 15px;
      display: flex;
      justify-content: space-between;
      height: 60px;
      border-bottom: 1px solid #f2f2f2;
      .left {
        align-self: center;
        text-align: left;
        // background-color: aqua;
        .top {
          font-size: 14px;
          color: #000000;
          font-weight: 600;
          margin-bottom: 5px;
        }
        .down {
          font-size: 11px;
          color: #999999;
        }
      }
      .right {
        line-height: 60px;
        font-size: 12px;
      }
      .red {
        color: #e60000;
      }
    }
    .lineView {
      width: 100%;
      height: 10px;
      background-color: #f2f2f2;
      padding-bottom: 44px;
    }
    .cancel {
      background-color: #ffffff;
      width: 100%;
      position: fixed;
      color: #e60000;
      height: 44px;
      line-height: 44px;
      bottom: constant(safe-area-inset-bottom) !important;
      bottom: env(safe-area-inset-bottom) !important;
      font-size: 14px;
      text-align: center;
    }
  }

  .popCheck {
    .check-file {
      margin-top: 15px;
      .check-detail {
        font-size: 14px;
        padding-right: 15px;
        margin-bottom: 15px;
        line-height: 30px;
        margin: 0px;
        text-align: right;
        color: rgb(255, 0, 0);
        cursor: pointer;
      }
      .check-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-items: flex-end;
        font-size: 14px;
        padding: 0 15px;
        position: sticky;
        span {
          color: rgb(255, 0, 0);
          cursor: pointer;
        }
        .checkStatus {
          flex: 1;
          margin-left: 5px;
        }
        @keyframes dot {
          0% {
            width: 0;
          }
          33% {
            width: 0.2em;
          }
          66% {
            width: 0.5em;
          }
          100% {
            width: 0.8em;
          }
        }
        .dot {
          color: #ff0000;
          // font-size: 18px;
          display: inline-block;
          width: 20px;
          vertical-align: bottom;
          overflow: hidden;
          animation: dot 3s infinite step-start;
        }
      }
      .check-list {
        height: 34vh;
        overflow: auto;
        border: 1px solid #f2f2f2;
        background: #fff;
        // height: 300px;
        margin-top: 10px;
        padding: 15px;
        .item-title1 {
          font-size: 14px;
          color: #000;
        }
        .check_item {
          height: 20px;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
        }
        .item-title3 {
          font-size: 13px;
          color: #666;
          font-weight: bold;
        }
        .item-title2 {
          font-size: 12px;
          color: #666;
        }
        .active {
          color: #2d8cf0;
        }
        .err {
          color: #e60000;
        }
        .ivu-icon {
          right: 15px;
          // top: 18px;
          font-size: 20px;
        }
        .item-status-img {
          width: 16px;
          height: 16px;
          right: 15px;
          // top: 18px;
          margin-top: 2px;
          margin-right: 2px;
          font-size: 20px;
        }
        .item-img {
          width: 20px;
          height: 20px;
          animation: spin 1s infinite linear;
        }
        @keyframes spin {
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
    // height: 60vh;
    background-color: #fff;
    width: 90vw;
    border-radius: 10px;
    position: relative;
    .topnav {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 101;
      padding-bottom: 10px;
    }
    .header {
      height: 42px;
      line-height: 42px;
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      border-bottom: 1px solid #f2f2f2;
      font-size: 14px;
    }
    .checkArea {
      display: flex;
      justify-content: space-between;
      background-color: #f0faff;
      border: 1px solid #abdcff;
      border-radius: 5px;
      margin: 10px 15px 0;
      padding: 5px 10px;
      font-size: 14px;
      position: relative;
      .title {
        margin-left: 26px;
        position: absolute;
      }
      .item-img {
        width: 20px;
        height: 20px;
        // right: 8px;
        // top: 6px;
        // position: absolute;
        animation: spin 1s infinite linear;
      }
      @keyframes spin {
        100% {
          transform: rotate(360deg);
        }
      }
    }
    .popBody {
      height: 30vh;
      overflow: auto;
    }
    .signature-desc {
      margin-top: 15px;
      // padding-bottom: 10px;
      .info-title {
        font-size: 14px;
        text-align: left;
        padding-left: 15px;
        margin-bottom: 10px;
      }
      .info-content {
        margin: 0 15px;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        color: #7f8997;
        padding: 8px;
        background: #f7f8f8;
        border: 1px solid #e5e7ea;
        border-radius: 4px;
        .content-item {
          color: #001330;
          text-align: left;
          margin-bottom: 10px;
          .item-value {
            color: #7f8997;
            font-size: 11px;
            word-break: break-all;
            .detail {
              float: right;
              color: red;
            }
          }
        }
      }
    }
    .popFooter {
      padding: 10px 15px;
      border-top: 1px solid #f2f2f2;
      display: flex;
      justify-content: flex-end;
      .btn {
        font-size: 14px;
        background-color: #e60000;
        color: #fff;
        text-align: center;
        width: 80px;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
      }
    }
  }
  .verity-modal {
    padding-top: 30px;
    padding-bottom: 10px;
    .id-warp {
      padding-bottom: 30px;
    }
    .ivu-form-item {
      margin-bottom: 10px;
    }
    .id-warp .title {
      min-width: 90px !important;
    }
    .content-last {
      width: 100%;
      text-align: right;
      color: #276ef9;
    }
    .werp-center {
      height: 30vh;
      overflow-y: auto;
      .info-warp {
        margin-bottom: 15px;
      }
      a {
        color: rgb(255, 0, 0);
      }
    }
    .item-value {
      flex: 1;
      word-break: break-word;
      .detail {
        // margin-left: 5px;
        width: 31px;
        // text-align: center;
      }
    }
    .verity-box {
      padding-left: 40px;
      padding-right: 40px;
      .ivu-form-item-label {
        padding-bottom: 18px;
      }
      .ivu-input-suffix {
        display: flex;
        align-items: center;
      }
      input {
        height: 44px;
      }
      .btn {
        margin-top: 32px;
        button {
          width: 100%;
          height: 44px;
        }
      }
    }
    .ivu-form-item-label {
      float: none;
      display: block;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
    }
    .ivu-modal-wrap {
      display: flex;
      align-items: center;
    }
    .tips {
      text-align: right;
      cursor: pointer;
      font-size: 12px;
      color: #888;
    }
    .ivu-modal {
      top: 0;
    }
  }
}
</style>

<style>
.home .van-nav-bar .van-icon {
  color: black;
  font-size: 20px;
}
.van-toast__text {
  width: 100px;
}
</style>
